// extracted by mini-css-extract-plugin
export var image = "topCover-module--image--aqUGd";
export var messages = "topCover-module--messages--kQ8MJ";
export var mission = "topCover-module--mission--BTkRI";
export var shade = "topCover-module--shade--A+aAn";
export var subMessage = "topCover-module--subMessage--0qG-V";
export var wrapper = "topCover-module--wrapper--yURt1";